<script>
export default {
    name: "OktaInitiatedSignIn",
    created: function() {
        this.$auth.loginRedirect();
    }
}
</script>